var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeftIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.67,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.825 6.25L9.25 11.918l5.575 5.76"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05 0H24v24H1.05C.47 24 0 23.664 0 23.25V.75C0 .336.47 0 1.05 0z"
}))));
export default SvgChevronLeftIconcom;